/* global google, markers */
import googleMapStyles from './styles';
$(function () {
  if (typeof markers === 'undefined') return;
  var map = new google.maps.Map(document.querySelector('.js-googleMap'), {
    maxZoom: 15,
    styles: googleMapStyles,
    disableDefaultUI: true
  });
  var bounds = new google.maps.LatLngBounds();
  var image = '/app/themes/brentwoodcap/resources/assets/images/drop_pin.png';
  var marker = new google.maps.Marker({
    position: new google.maps.LatLng(markers.lat, markers.lng),
    map: map,
    icon: image
  });
  bounds.extend(marker.position);
  map.fitBounds(bounds);
});